import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
  roles?: string[];
}

interface CustomJwtPayload {
  'custom:roles'?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ roles }) => {
  const { token } = useAuth();

  if (!token) {
    return <Navigate to="/login" />;
  }

  const decodedToken = jwtDecode<CustomJwtPayload>(token);
  const userRoles = decodedToken['custom:roles'] ? decodedToken['custom:roles'].split(',').map(role => role.trim()) : ['user'];

  if (roles && !roles.some(role => userRoles.includes(role))) {
    return <Navigate to="/unauthorized" />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
